'use client';
import PropTypes from 'prop-types';
import {useState} from 'react';
import dynamic from 'next/dynamic';
import {useFormContext} from 'react-hook-form';
import {IconX} from '@tabler/icons-react';
import {Button, Divider, FormHelperText, Grid, Typography} from '@mui/material';
import {RHFMultilingualField} from '@/shared/components/forms/theme-elements/form/RHFMultilingualField';
const FileUploader = dynamic(
  () =>
    import('@/shared/components/forms/theme-elements/form/fileUploader').then(
      (mod) => mod.FileUploader
    ),
  {ssr: false}
);

export const SecurityItemsList = ({name, values, errors, listType}) => {
  const [fileLoading, setFileLoading] = useState(false);

  const {setValue} = useFormContext();

  const removeSecurity = ({securityItemIndex}) => {
    setValue(
      name,
      (values || []).filter((_, ind) => ind !== securityItemIndex)
    );
  };

  const addSecurity = () => {
    setValue(name, [
      ...(values || []),
      {
        title: {en: '', nl: ''},
        description: {en: '', nl: ''},
        image: '',
      },
    ]);
  };

  return (
    <Grid>
      {values?.map((security, securityItemIndex) => {
        return (
          <Grid key={security.id || `security-${securityItemIndex}`}>
            <Grid>
              <Grid
                display='flex'
                alignItems='center'
                justifyContent={'space-between'}
                mb={2}
              >
                <Typography variant='h6'>Title</Typography>
                <IconX
                  color='red'
                  onClick={() => removeSecurity({securityItemIndex})}
                />
              </Grid>

              <RHFMultilingualField
                name={`${name}[${securityItemIndex}].title`}
              />
            </Grid>

            <Typography variant='h6' mb={2}>
              Description
            </Typography>

            <RHFMultilingualField
              name={`${name}[${securityItemIndex}].description`}
            />

            <Typography variant='h6' mb={2}>
              Image
            </Typography>
            <Grid sx={{width: '50%'}}>
              <FileUploader
                meta={{shape: 'Rectangle', size: {width: 350, height: 300}}}
                label={'Security Image'}
                name={`${name}[${securityItemIndex}].image`}
                setFileUrl={(links) =>
                  setValue(`${name}[${securityItemIndex}].image`, links[0])
                }
                destination={'landing-pages'}
                values={values?.[securityItemIndex]?.image}
                setFileLoading={setFileLoading}
                setValue={setValue}
              />
            </Grid>

            <Divider sx={{my: 2}} />
          </Grid>
        );
      })}

      <center>
        <Button size='small' color={'error'} onClick={() => addSecurity()}>
          Add New {listType} Item
        </Button>
      </center>

      {errors && (
        <FormHelperText sx={{color: 'error.main', ml: -0.01, mb: 1}}>
          {errors?.message}
        </FormHelperText>
      )}
    </Grid>
  );
};

SecurityItemsList.propTypes = {
  listType: PropTypes.string,
  name: PropTypes.string.isRequired,
  values: PropTypes.array,
  errors: PropTypes.object,
};
